import React from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { C, TABULAR, tdStyle } from "../styles";
import { fmtDate, fmtMoney } from "../helpers";
import type { PayRun } from "../types";

interface PayRunRowProps {
  payRun: PayRun;
}

export default function PayRunRow({ payRun: r }: PayRunRowProps) {
  const navigate = useNavigate();
  const isDraft = r.status === "draft";

  return (
    <tr
      onClick={() => navigate("/payroll/run/" + r.id + (isDraft ? "" : "/done"))}
      style={{
        borderBottom: "1px solid " + C.lineSoft,
        cursor: "pointer",
      }}
    >
      <td style={tdStyle}>
        {fmtDate(r.pay_period_start)} to {fmtDate(r.pay_period_end)}
      </td>
      <td style={{ ...tdStyle, ...TABULAR }}>{fmtDate(r.pay_date)}</td>
      <td style={{ ...tdStyle, textAlign: "right", ...TABULAR }}>
        {r.employee_count || 0}
      </td>
      <td
        style={{
          ...tdStyle,
          textAlign: "right",
          fontWeight: 600,
          ...TABULAR,
        }}
      >
        {fmtMoney(r.total_net)}
      </td>
      <td style={tdStyle}>
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            fontSize: 11,
            fontWeight: 700,
            color: isDraft ? C.amber : C.brandDark,
            background: isDraft ? C.amberBg : C.brandBg,
            padding: "3px 10px",
            borderRadius: 5,
            letterSpacing: "0.04em",
            textTransform: "uppercase",
          }}
        >
          <span
            style={{
              width: 6,
              height: 6,
              background: isDraft ? C.amber : C.brandDark,
              borderRadius: "50%",
            }}
          />
          {isDraft ? "Draft" : "Finalized"}
        </span>
      </td>
      <td style={{ ...tdStyle, textAlign: "right" }}>
        <Search size={16} style={{ color: C.brand, cursor: "pointer" }} />
      </td>
    </tr>
  );
}